import coreLogger from '../../utils/log/coreLogger';
import useScopedSelector from '../useScopedSelector';

export type DispatchAction = (...args: unknown[]) => void;
type EmptyAction = (() => void);

const useScopedDispatch = <
  SelectedAction extends DispatchAction = DispatchAction
>(actionPath: string): SelectedAction | Record<string, SelectedAction | EmptyAction> | DispatchAction | EmptyAction => {
  const actions = useScopedSelector<Record<string, SelectedAction>>(actionPath);

  if (typeof actions === 'object') {
    return Object.keys(actions).reduce<Record<string, SelectedAction | EmptyAction>>((result, actionName) => {
      if (!actions[actionName]) {
        result[actionName] = () => {
          coreLogger.warn(`useScopedDispatch: Action "${actionName}" could not be located.`);
        };
      } else {
        result[actionName] = actions[actionName];
      }
      return result;
    }, {});
  }

  if (typeof actions === 'undefined') {
    return () => {
      coreLogger.warn(`useScopedDispatch: Action "${actionPath}" could not be located.`);
    };
  }

  return actions;
};

/**
 * @visibleName useScopedDispatch
 * @component
 */
export default useScopedDispatch;
